
/*-- import aliases -----------
'!/...' -> project root
'~/...' -> vue folder root
'@/...' -> src folder root
-----------------------------*/

import Vue from 'vue';
import Store from '@/filtering/store';
import App from '@/filtering/App';
import Blue from '../js/core';

Vue.config.devtools = true;
Vue.config.productionTip = false;

new Blue({
  name: 'filtering',
  selector: '.app_filtering',
  setup(el) {
    const data = Object.assign({}, el.dataset);
    const items = el.nextElementSibling;
		const highlights = items.nextElementSibling || false;
    data.items = [...items.querySelectorAll(':scope > *')].map(item => item.outerHTML);
		if (highlights) {
			data.highlights = [...highlights.querySelectorAll(".program-highlight")].map(highlight => highlight.outerHTML);
			const heading = highlights.querySelector(".program-highlights__heading") || false;
			if (heading) data.highlightsHeading = heading.textContent;
		}
    items.remove();
    const app = new Vue({
      store: new Store().store,
      data: () => data,
      render: h => h(App)
    });
    app.$mount(el)
  }
}, false)